import { FirmAdmin } from 'components/FirmAdminList/FirmAdminInterface/FirmAdminInterface';
import { AdminViewModel } from 'store/admins/types';

export const getAdminsForList = (state: FirmAdmin[]): AdminViewModel[] => {
  return state.map((admin) => ({
    id: admin.id.toString(),
    name: `${admin.first_name} ${admin.last_name}`,
    company: admin.company.name,
    email: admin.email,
    fcaNumber: admin.company.fca_number,
    isVerified: admin.is_verified,
    role: admin.role,
    activeLabel: admin.is_verified ? 'YES' : 'No',
    buttonActivationLabel: admin.is_verified ? 'Unverify' : 'Verify',
    location: admin.city,
  }));
};
